module.exports = __webpack_public_path__ + "static/img/2.b7bb0d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/eng/2.png
// module id = HCTx
// module chunks = 0